import React, { Component } from "react";
import { Drawer } from "material-ui";
import { isMobile } from "../../../../hocs";

class ClientPortalDrawer extends Component {
  static defaultProps = {
    docked: false,
    openSecondary: true
  };
  onRequestChange = open => {
    this.props.onRequestChange(open);
  };
  render() {
    const { onRequestChange, isMobile, ...restProps } = this.props;
    let width = isMobile ? "85%" : "50%";

    return (
      <Drawer
        {...restProps}
        width={width}
        onRequestChange={this.onRequestChange}
        containerClassName="select-drawer"
        swipeAreaWidth={0}
      >
        {this.props.children}
      </Drawer>
    );
  }
}

const CustomDrawer = isMobile(ClientPortalDrawer);
export { CustomDrawer };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/Drawer.js